/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';

interface FormsSuggestedProviderModalProviderButtonArgs {
  styleAsSetupGuideOption?: boolean;
  link: string;
  title: string;
  isBold?: boolean;
  iconUrl: string;
}

export default class FormsSuggestedProviderModalProviderButton extends Component<FormsSuggestedProviderModalProviderButtonArgs> {
  @service analytics!: AnalyticsService;

  @action
  trackClicked() {
    this.analytics.track('forms', 'form_builder_clicked', {
      integrationName: this.args.title,
    });
  }
}
